import React from "react"
import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa"
import tw from "tailwind.macro"
import Button from "./button"

const SharingButtons = ({ title, url, ...other }) => {
  return (
    <>
      <Button
        to={`https://wa.me/?text=${title} ${url}`}
        css={[tw`text-2xl leading-none mr-2`, `background:#25d366`]}
      >
        <FaWhatsapp />
      </Button>
      <Button
        to={`https://www.facebook.com/sharer.php?u=${url}`}
        css={[tw`text-2xl leading-none mr-2`, `background:#3b5998`]}
      >
        <FaFacebook />
      </Button>
      <Button
        to={`https://twitter.com/share?url=${url}&text=${title}`}
        css={[tw`text-2xl leading-none mr-2`, `background:#1da1f2`]}
      >
        <FaTwitter />
      </Button>
      <Button
        to={`https://www.linkedin.com/shareArticle?url=${url}&title=${title}`}
        css={[tw`text-2xl leading-none mr-2`, `background:#0077b5`]}
      >
        <FaLinkedin />
      </Button>
    </>
  )
}

export default SharingButtons
